import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProfileResponse } from '../model/profile-response.model';
import { QuestionDoc } from './question-doc.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileDetailService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  getQuestionProfiles(pan: string) {
    return this.httpClient.get<ProfileResponse>(ApiUrls.profileDetailsUrl.replace('{pan}', pan));
  }

  fetchPhoto(pan: string) {
    return this.httpClient.get<QuestionDoc>(ApiUrls.fetchRegPhotoUrl.replace('{pan}', pan));
  }

  fetchQuestionDoc(pan: string, questionCode: string) {
    return this.httpClient.get<QuestionDoc>(ApiUrls.fetchQuestionDocUrl.replace('{pan}', pan).replace('{questionCode}', questionCode));
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}
